<h1 mat-dialog-title>{{ObjectType}} Data</h1>

<div mat-dialog-content class="col-md-12">
  @if(ObjectType == "Motor"){
  <h6>{{SelectedActuator.Name + " " + SelectedMotor.Name}}</h6>
  }
  @if(ObjectType == "Feedback"){
  <h6>{{SelectedFeedback.Code}}</h6>
  }

  <div>
    <table class="pinTable" style="width:100%;">
      @for(dat of ColumnsToShow; track dat){
      <tr>
        <td style="width:50%;">{{dat.CustomText == "" ? dat.DBColumn.DisplayText : dat.CustomText}}</td>
        <td style="width:50%;"><app-datavalue [DataColumn]="dat" [InitialUnit]="GetUnitFromUOM(dat.DefaultUOM, dat.DefaultUOM)" [InitialValue]="GetDataValue(dat.DBColumnName, dat.DefaultValue)"></app-datavalue></td>
      </tr>
      }
    </table>
  </div>
</div>
<div mat-dialog-actions class="center">
  <button mat-button (click)="onNoClick()">Close</button>  
</div>
